import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/** Persistent banner shown while an admin is acting as another account. */
export default function ImpersonationBanner() {
  const { impersonator, user, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  if (!impersonator) return null;
  const exit = async () => {
    try { await stopImpersonation(); } catch (_) { /* ignore */ }
    navigate("/admin");
  };
  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-400 text-[#071b22] shadow-md" data-testid="impersonation-banner">
      <div className="mx-auto max-w-7xl px-4 py-2 flex items-center gap-3 text-sm">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">
          Support mode — acting as <strong>{user?.display_name || user?.email}</strong>. Changes affect their account.
        </span>
        <button onClick={exit} className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-[#071b22] text-white px-3 py-1 text-xs font-medium hover:bg-black transition-colors" data-testid="impersonation-exit">
          <LogOut className="h-3.5 w-3.5" /> Exit support mode
        </button>
      </div>
    </div>
  );
}
